import axiosPrivate from "./axiosPrivate";

const getGestionServicio = (periodo, estado) => {
    return axiosPrivate.get("gestion-servicio", {
        params: { periodo, estado }
    })
        .then(response => response.data);
};

const insertGestionServicio = (data) => {
    return axiosPrivate.post("gestion-servicio", data)
        .then(response => response.data);
};

const updateGestionServicio = (data) => {
    return axiosPrivate.put("gestion-servicio", data)
        .then(response => response.data);
};

const deleteGestionServicio = (data) => {
    return axiosPrivate.delete("gestion-servicio", { data })
        .then(response => response.data);
};

export default {
    getGestionServicio,
    insertGestionServicio,
    updateGestionServicio,
    deleteGestionServicio
};